
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf/pro-shop/gift-certificates",
      function () {
        return require("private-next-pages/golf/pro-shop/gift-certificates.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf/pro-shop/gift-certificates"])
      });
    }
  